import React from 'react';

export default function DownloadsPage({ history = [], onBack }) {
  const reversed = history.slice().reverse();

  return (
    <div className="min-h-screen bg-[#0B0B12] text-white px-4 py-6 sm:px-8 sm:py-8">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <button onClick={onBack} className="text-sm text-white/50 hover:text-white transition">← Back</button>
          <h2 className="text-xl font-bold tracking-tight">Downloads</h2>
          <span className="w-12" />
        </div>

        {!history.length ? (
          <div className="text-center py-16 text-white/30 rounded-3xl ring-1 ring-white/5 bg-white/[0.02]">
            Nothing generated yet this session. Head to "Generate Sales Kit" to create one.
          </div>
        ) : (
          <>
            {/* Desktop table */}
            <div className="hidden md:block overflow-x-auto rounded-2xl ring-1 ring-white/10 bg-[#14141C]">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-[11px] uppercase tracking-widest text-white/40 border-b border-white/5">
                    <th className="px-4 py-3 font-semibold">Generated At</th>
                    <th className="px-4 py-3 font-semibold"># Companies</th>
                    <th className="px-4 py-3 font-semibold">Artifacts</th>
                  </tr>
                </thead>
                <tbody>
                  {reversed.map((h) => (
                    <tr key={h.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.03] transition">
                      <td className="px-4 py-3 text-white/70">{new Date(h.createdAt).toLocaleString()}</td>
                      <td className="px-4 py-3 text-white/70">{h.companyIds.length}</td>
                      <td className="px-4 py-3 text-white/50 text-xs">{Object.keys(h.data).join(', ')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile cards */}
            <div className="md:hidden space-y-3">
              {reversed.map((h) => (
                <div key={h.id} className="rounded-2xl bg-[#14141C] ring-1 ring-white/10 p-4">
                  <p className="text-sm font-semibold">{new Date(h.createdAt).toLocaleString()}</p>
                  <p className="text-xs text-white/40 mt-1">{h.companyIds.length} companies</p>
                  <p className="text-xs text-white/50 mt-2">{Object.keys(h.data).join(', ')}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
